<store-locator-seo
	*ngIf="site$ | async"
	[storeDetails]="site$ | async"
	[tradingHours]="tradingHours$ | async"
	[pharmacyDetails]="pharmacyStore$ | async"
	[pharmacyTradingHours]="pharmacyTradingHours$ | async"
	[defaultStoreImage]="seoImage"
></store-locator-seo>
<section [ngClass]="{'no_breadcrumb': !showBreadcrumb}">
	<nav *ngIf="showBreadcrumb">
		<cdx-breadcrumb></cdx-breadcrumb>
	</nav>
	<div class="storeDetails-dynamicContent" *ngIf="isMobile$ | async">
		<ng-container *ngTemplateOutlet="dynamicContent"></ng-container>
	</div>
	<div class="storeDetails-section storeDetails-section--white">
		<div class="storeDetails-header">
			<ng-container *ngIf="(isMobile$ | async) === false">
				<ng-container *ngTemplateOutlet="dynamicContent"></ng-container>
			</ng-container>
			<ng-container *ngTemplateOutlet="storeDetailHeader"></ng-container>
		</div>

		<ng-container *ngTemplateOutlet="storeMap"></ng-container>
	</div>

	<ng-template #dynamicContent>
		<div #dynamicContentPanel id="dynamic-content-panel" class="dynamic-content-canvas"></div>
	</ng-template>

	<ng-template #storeDetailHeader>
		<store-locator-details-header
			[storeDetail]="site$ | async"
			[tradingHours]="tradingHours$ | async"
			[liquorTradingHours]="liquorTradingHours$ | async"
			(directionsClick)="handleDirectionsClick($event)"
		>
		</store-locator-details-header>
	</ng-template>

	<ng-template #storeMap>
		<store-locator-google-stores-map
			*ngIf="siteDetail$ | async; let siteDetail"
			class="storeDetails-map"
			[apiKey]="apiKey"
			[stores]="[siteDetail]"
		>
		</store-locator-google-stores-map>
	</ng-template>
</section>

<ng-container *ngIf="services$ | async; let services">
	<section
		class="storeDetails-section storeDetails-section--transparent storeDetails-section--padding"
		*ngIf="services?.length"
	>
		<store-locator-details-service [services]="services"></store-locator-details-service>
	</section>
</ng-container>

<ng-container *ngIf="pharmacyStore$ | async; let pharmacyDetail">
	<section>
		<div
			class="storeDetails-section storeDetails-section--white storeDetails-section--padding storeDetails-section--left"
		>
			<store-locator-pharmacy
				[pharmacyDetail]="pharmacyDetail"
				[tradingHours]="pharmacyTradingHours$ | async"
			></store-locator-pharmacy>
		</div>
	</section>
</ng-container>
